import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Avatar,
  Stack,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function Thankyou2() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleMyAccountClick = () => {
    navigate("/iWallet");
  };

  return (
    <Box
      sx={(theme) => ({
        background: theme.palette.background.cardGradient,
        borderRadius: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
      })}
    >
      <Card
        className="badges-inner-sec"
        sx={(theme) => ({
          background: theme.palette.background.cardGradient,
          color: "#fff",
          maxWidth: 400,
          textAlign: "center",
          borderRadius: 4,
          p: 3,
          border: "10px solid var(--headerbg)",
          maxWidth: "660px",
          width: "100%",
        })}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", mb: 2, color: "#FFA726" }}
        >
          <img
            src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/logo-header.svg`}
            alt="logo"
          />
        </Typography>
        <Avatar
          sx={{
            bgcolor: "green",
            color: "var(--white)",
            width: 56,
            height: 56,
            mx: "auto",
            mb: 2,
          }}
        >
          <CheckCircleIcon fontSize="large" />
        </Avatar>
        <Typography variant="h3" fontWeight={600} gutterBottom>
          {t("IWallet.title")}
        </Typography>
        <CardContent
          sx={{
            bgcolor: "var(--headerbg)",
            borderRadius: 2,
            mb: 3,
          }}
        >
          <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
            {t("IWallet.message1")}
          </Typography>
          <Typography variant="body2" color="secondary.text">
            {t("IWallet.message2")}{" "}
          </Typography>
        </CardContent>
        <Stack
          alignItems={"center"}
          pt={2}
          sx={{ borderTop: "1px solid var(--headerbg)" }}
        >
          <Button
            variant="contained"
            onClick={handleMyAccountClick}
            sx={{
              bgcolor: "#FFA726",
              color: "#000",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: "#fb8c00",
              },
            }}
          >
            {t("IWallet.myAccount")}
          </Button>
        </Stack>
      </Card>
    </Box>
  );
}
